import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { FuiDialog } from '@fui/fui-components';
import { ITableDataRow } from '../../profiler.interface';
import { ProfilerService } from '../../profiler.service';
import { DetailsDialogComponent } from '../details-dialog/details-dialog.component';

@Component({
    templateUrl: './profiler-page.component.html',
    styleUrls: ['./profiler-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilerPageComponent implements OnInit {
    private readonly dialog = inject(Dialog);

    readonly dictionary = inject(LANG_DICTIONARY_TOKEN);
    readonly profilerService = inject(ProfilerService);
    readonly appService = inject(AppService);

    ngOnInit() {
        AppHelper.getCreateAccessTableButton(
            this.profilerService.buttons,
            {
                show: 1,
            },
            this.profilerService,
            {
                show: true,
            },
        );
    }

    onRowClick(row: any) {
        FuiDialog.open<ITableDataRow, void, DetailsDialogComponent>(this.dialog, DetailsDialogComponent, row);
    }
}
